import React from 'react';
import { X, Check, CheckCircle2 } from 'lucide-react';
export function WhatSynthiaDoes() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-black text-white" data-id="element-1250">
      <div className="max-w-7xl mx-auto" data-id="element-1251">
        <div className="mb-16 text-center" data-id="element-1252">
          <h2 className="text-4xl md:text-5xl font-bold font-['Syne'] text-white mb-6" data-id="element-1253">
            What Synthia does
          </h2>
          <p className="text-xl text-zinc-400 font-light max-w-4xl leading-relaxed mx-auto" data-id="element-1254">
            Synthia provides the instructions AI needs to answer these questions
            correctly—using your institutional intelligence, not internet
            averages. Less compute, less tokens, less waste.
          </p>
        </div>

        {/* Comparison Section */}
        <div className="flex justify-center" data-id="element-1255">
          <div className="w-full max-w-5xl border border-zinc-800 rounded-2xl overflow-hidden bg-zinc-900/30 backdrop-blur-sm" data-id="element-1256">
            {/* Card Header */}
            <div className="bg-zinc-900/80 border-b border-zinc-800 px-6 py-4 flex justify-center" data-id="element-1257">
              <p className="text-zinc-400 text-xs font-mono tracking-[0.2em] uppercase" data-id="element-1258">
                Example: Financial Services Client Communications
              </p>
            </div>

            <div className="grid md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-zinc-800" data-id="element-1259">
              {/* Left Column - Without Synthia */}
              <div className="p-8 md:p-12 flex flex-col h-full bg-zinc-900/20" data-id="element-1260">
                <div className="flex items-center gap-3 mb-8" data-id="element-1261">
                  <div className="w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center border border-red-500/20" data-id="element-1262">
                    <X className="w-4 h-4 text-red-500" data-id="element-1263" />
                  </div>
                  <h3 className="text-xl font-semibold text-zinc-300" data-id="element-1264">
                    Without Synthia
                  </h3>
                </div>

                <p className="text-xs font-bold text-red-400 tracking-widest uppercase mb-6" data-id="element-1265">
                  AI Guesses:
                </p>

                <ul className="space-y-4 mb-12 flex-grow" data-id="element-1266">
                  {['Who is the audience?', 'What tone is appropriate?', 'Which rules apply?', 'What can I say?', 'How formal should I be?'].map((item, i) => <li key={i} className="flex items-start gap-3 text-zinc-400" data-id="element-1267">
                      <X className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-1268" />
                      <span className="text-sm font-medium" data-id="element-1269">{item}</span>
                    </li>)}
                </ul>

                <div className="mt-auto" data-id="element-1270">
                  <div className="bg-red-950/30 border border-red-900/50 rounded-lg px-4 py-4 flex items-center gap-3" data-id="element-1271">
                    <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-1272" />
                    <p className="text-sm font-medium text-red-200" data-id="element-1273">
                      Result:{' '}
                      <span className="text-red-400" data-id="element-1274">
                        Generic, risky, multiple review cycles
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              {/* Right Column - With Synthia */}
              <div className="p-8 md:p-12 flex flex-col h-full bg-zinc-900/40 relative overflow-hidden" data-id="element-1275">
                {/* Subtle glow effect for the "good" side */}
                <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-1276" />

                <div className="flex items-center gap-3 mb-8 relative z-10" data-id="element-1277">
                  <div className="w-8 h-8 rounded-full bg-emerald-500/10 flex items-center justify-center border border-emerald-500/20" data-id="element-1278">
                    <Check className="w-4 h-4 text-emerald-500" data-id="element-1279" />
                  </div>
                  <h3 className="text-xl font-semibold text-white" data-id="element-1280">
                    With Synthia
                  </h3>
                </div>

                <p className="text-xs font-bold text-emerald-400 tracking-widest uppercase mb-6 relative z-10" data-id="element-1281">
                  AI Knows:
                </p>

                <ul className="space-y-4 mb-12 flex-grow relative z-10" data-id="element-1282">
                  {['Sell-side trading desk', 'Data-heavy, transactional', 'SEC/FINRA compliant', 'No forward-looking claims', 'Executive-level authority'].map((item, i) => <li key={i} className="flex items-start gap-3 text-zinc-100" data-id="element-1283">
                      <CheckCircle2 className="w-4 h-4 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-1284" />
                      <span className="text-sm font-medium" data-id="element-1285">{item}</span>
                    </li>)}
                </ul>

                <div className="mt-auto relative z-10" data-id="element-1286">
                  <div className="bg-emerald-950/30 border border-emerald-900/50 rounded-lg px-4 py-4 flex items-center gap-3" data-id="element-1287">
                    <div className="w-2 h-2 rounded-full bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.5)]" data-id="element-1288" />
                    <p className="text-sm font-medium text-emerald-100" data-id="element-1289">
                      Result:{' '}
                      <span className="text-emerald-400" data-id="element-1290">
                        Client-ready, minimal reviews
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}